module.exports = __webpack_public_path__ + "img/Feldlager.d65810e7.svg";